var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1E1450"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6006 10.4095C21.254 10.0628 20.694 10.0628 20.3473 10.4095L16.0006 14.7473L11.654 10.4006C11.3073 10.054 10.7473 10.054 10.4006 10.4006C10.054 10.7473 10.054 11.3073 10.4006 11.654L14.7473 16.0006L10.4006 20.3473C10.054 20.694 10.054 21.254 10.4006 21.6006C10.7473 21.9473 11.3073 21.9473 11.654 21.6006L16.0006 17.254L20.3473 21.6006C20.694 21.9473 21.254 21.9473 21.6006 21.6006C21.9473 21.254 21.9473 20.694 21.6006 20.3473L17.254 16.0006L21.6006 11.654C21.9384 11.3162 21.9384 10.7473 21.6006 10.4095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.de233e00fa9ebd9751fa5ab054f2454f.svg";
export { ForwardRef as ReactComponent };